import React from 'react'
import { string } from 'prop-types'

import Container from 'components/atoms/Container'
import SectionContainer from 'components/atoms/SectionContainer'
import Typography from 'components/atoms/Typography'

import config from 'config'

const { assets_url: assetsUrl } = config
const aptReportAssetsPath = `${assetsUrl}/assets/img/aptitude/report`

const AptitudeGreeting = ({ name }) => (
  <div className="aptitude-greeting">
    <SectionContainer
      paddingTop={80}
      paddingBottom={120}
      backgroundColor="transparent"
    >
      <Container>
        <div className="aptitude-greeting__wrapper">
          <Typography component="h2" variant="title" className="text-variant-title-sm m-b-md">Hi {name}!</Typography>
          <Typography component="p" variant="headline">RIASEC merupakan alat pengukuran yang paling sering digunakan dalam membuat perencanaan karier di masa depan.</Typography>
        </div>
      </Container>
    </SectionContainer>
    <style jsx>
      {`
        .aptitude-greeting {
          background-image: url(${aptReportAssetsPath}/result.png), url(${aptReportAssetsPath}/rectangle.png);
          background-repeat: no-repeat;
          background-position: 80% bottom, center;
          background-size: auto, cover;
          
          @media screen and (max-width: 767px) {
            background-size: 90%, cover;
            background-position: bottom;
            &__wrapper {
              margin-bottom: 160px;
            }
          }
          @media screen and (min-width: 768px) {
            &__wrapper {
                margin: 0 250px 50px 0;
              }
            &__greeting-text {
              margin: 40px 0 0 140px;
            }
          }
        }
      `}
    </style>
  </div>
)

AptitudeGreeting.propTypes = {
  name: string,
}

export default AptitudeGreeting
